import { ProjInfo } from "@/model/proj/ProjInfo";
import { QuerySrcPos } from "@/model/request/proj/query/QuerySrcPos";
import { QueryProjInfo } from "@/model/request/proj/query/QueryProjInfo";
import { getCurPdfPage } from "@/service/project/preview/PreviewService";
import {
  getProjectInfo,
  getSrcPosition,
  sendQueueCompileRequest,
} from "@/service/project/ProjectService";
import { toast } from "react-toastify";
import i18n from "i18next";
import { getPreviewUrl } from "@/service/file/FileService";
import { ResponseHandler } from "rdjs-wheel";
import { scrollToOffset } from "../doc/PDFPreviewHandle";
import { ListImperativeAPI } from "react-window";
import { readConfig } from "@/config/app/config-reader";
import { SocketIOClientProvider } from "texhub-broadcast";
import { buildPdfHttpHeaders } from "@/config/pdf/PdfJsConfig";

/**
 * get the source location by pdf file position
 *
 * @returns src position info
 */
export const handleSrcLocate = (
  projectId: string,
  curProjInfo: ProjInfo,
  msg: string
) => {
  if (!projectId) {
    toast.info(msg);
    return;
  }
  let curPage = getCurPdfPage(projectId);
  let req: QuerySrcPos = {
    project_id: projectId,
    main_file: curProjInfo?.main_file.name || "main.tex",
    page: Number(curPage) || 1,
    h: 3.565,
    v: 4.563,
  };
  getSrcPosition(req);
};

export const handleOpenInBrowserDirect = (projectId: string) => {
  if (projectId) {
    getPreviewUrl(projectId).then((res) => {
      if (ResponseHandler.responseSuccess(res)) {
        window.open(res.result, "_blank");
      }
    });
  }
};

export const debugApp = (
  virtualListRef: React.RefObject<ListImperativeAPI | null>,
  projectId: string
) => {
  let offset = localStorage.getItem("pdfScrollOffset");
  if (offset) {
    const key = "default:" + readConfig("pdfScrollKey") + projectId;
    let defaultScroll = localStorage.getItem(key);
    console.log("defaultScroll:" + defaultScroll);
    const keyFullscreen =
      "fullscreen:" + readConfig("pdfScrollKey") + projectId;
    let fullScroll = localStorage.getItem(keyFullscreen);
    console.log("fullScroll:" + fullScroll);
    scrollToOffset(parseInt(offset), virtualListRef, projectId);
  }
};

export const handleOpenInBrowser = (projectId: string) => {
  if (projectId) {
    let url = "/tex/file/pdf/full?proj_id=" + projectId;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...buildPdfHttpHeaders(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank")!.focus();
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

export const handleDownloadPdf = async (
  pdfUrl: string,
  projName?: string,
  projectId?: string,
) => {
  if (!pdfUrl) {
    toast.error(i18n.t("err_pdf_url_empty"));
    return;
  }
  let fileName = projName;
  if (!fileName && projectId) {
    const req: QueryProjInfo = { project_id: projectId };
    try {
      const resp = await getProjectInfo(req);
      if (ResponseHandler.responseSuccess(resp)) {
        fileName = resp.result?.main?.proj_name;
      }
    } catch (err) {
      console.error("Error fetching project name for download:", err);
    }
  }
  if (!fileName) {
    fileName = "project_" + (projectId || new Date().getTime());
  }
  try {
    const response = await fetch(pdfUrl, {
      method: "GET",
      headers: buildPdfHttpHeaders(),
    });
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute(
      "download",
      fileName.replace(/[\\/:*?"<>|]/g, "_") + ".pdf",
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};

export const compile = (prj_id: string) => {
  let params = {
    project_id: prj_id,
  };
  sendQueueCompileRequest(params).then((resp) => {
    if (ResponseHandler.responseSuccess(resp)) {
    }
  });
};
